export const SET_CHECK_RESULT_CODE = "SET_CHECK_RESULT_CODE";

export function setCheckResultCode(payload) {
  return {
    type: SET_CHECK_RESULT_CODE,
    payload,
  };
}